import React from 'react';
import WeeklyActivityPreviewPublic from './WeeklyActivityPreviewPublic';
import WeeklyActivityPreviewBanquetCard from './WeeklyActivityPreviewBanquetCard';

const sectionTitle = {
  fontSize: 13,
  fontWeight: 600,
  color: '#444',
  marginBottom: 8,
};

function PreviewBlock({ title, visible, hiddenHint, children }) {
  return (
    <div style={{ opacity: visible ? 1 : 0.75 }}>
      <div style={sectionTitle}>{title}</div>
      {!visible && hiddenHint && (
        <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>{hiddenHint}</div>
      )}
      {children}
    </div>
  );
}

/**
 * 即時預覽：上下並排（無 Tab）
 * @param modes ['public','banquet'] 預設兩者；主辦端傳 ['public']
 */
export default function WeeklyActivityPreviewPanel({
  activity,
  sticky,
  modes = ['public', 'banquet'],
}) {
  const a = activity || {};
  const showPublic = a.is_public !== false;
  const showInternal = a.is_internal !== false;
  const showPub = modes.includes('public');
  const showBanquet = modes.includes('banquet');

  return (
    <div style={{
      ...(sticky ? { position: 'sticky', top: 12 } : {}),
      background: '#fafafa',
      borderRadius: 10,
      padding: 14,
      border: '1px solid #e8e8e8',
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      maxHeight: sticky ? 'calc(100vh - 120px)' : undefined,
      overflowY: sticky ? 'auto' : undefined,
    }}
    >
      {showPub && (
        <PreviewBlock
          title="前台月曆"
          visible={showPublic}
          hiddenHint="未勾選：行事曆不會顯示"
        >
          <WeeklyActivityPreviewPublic activity={a} />
        </PreviewBlock>
      )}
      {showBanquet && (
        <PreviewBlock
          title="櫃台活動"
          visible={showInternal}
          hiddenHint="未勾選：櫃台活動列表不會顯示"
        >
          <WeeklyActivityPreviewBanquetCard activity={a} />
        </PreviewBlock>
      )}
    </div>
  );
}
